import React, { useState } from 'react';
import api from '../services/api';

interface Props {
  onComplete: () => void;
}

const Onboarding: React.FC<Props> = ({ onComplete }) => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    nume: '', problema: 'Sciatică', durata_problema: 'Sub 2 săptămâni',
    varsta: '18-30 ani', stil_viata: 'Sedentar (birou, condus mult)',
    nivel_durere_initial: 5, obiectiv: ''
  });

  const update = (field: string, value: any) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSubmit = async () => {
    if (!form.nume) { setError('Spune-ne cum te cheamă!'); return; }
    setLoading(true);
    try {
      await api.post('/profil/salveaza', form);
      onComplete();
    } catch {
      setError('Eroare la salvare!');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    padding: '0.75rem', borderRadius: '10px',
    border: '1.5px solid #2a2a4a', background: '#12121f',
    color: '#e0e0f0', fontSize: '1rem', width: '100%',
    boxSizing: 'border-box' as const
  };

  const progres = (step / 3) * 100;

  return (
    <div style={{
      minHeight: '100vh', background: '#12121f',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'DM Sans, sans-serif', padding: '1rem'
    }}>
      <div style={{
        background: '#1a1a30', borderRadius: '16px', padding: '2.5rem',
        width: '100%', maxWidth: '500px', border: '1px solid #2a2a4a'
      }}>
        <h2 style={{ color: '#fff', marginBottom: '0.5rem' }}>🩺 Bun venit la Flexara!</h2>
        <p style={{ color: '#8080a0', marginBottom: '1rem' }}>Câteva întrebări rapide pentru a te ajuta mai bine.</p>

        <div style={{ background: '#2a2a4a', borderRadius: '99px', height: '6px', marginBottom: '2rem' }}>
          <div style={{ background: 'linear-gradient(90deg, #4a4ad8, #8080ff)', borderRadius: '99px', height: '6px', width: `${progres}%`, transition: 'width 0.3s' }} />
        </div>

        {error && <p style={{ color: '#ff6060', marginBottom: '1rem' }}>{error}</p>}

        {step === 1 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <h3 style={{ color: '#fff' }}>Pasul 1 — Despre tine</h3>
            <input placeholder="Cum te cheamă?" value={form.nume}
              onChange={e => update('nume', e.target.value)} style={inputStyle} />
            <select value={form.varsta} onChange={e => update('varsta', e.target.value)} style={inputStyle}>
              {['18-30 ani','31-45 ani','46-60 ani','Peste 60 ani'].map(v => <option key={v}>{v}</option>)}
            </select>
            <select value={form.stil_viata} onChange={e => update('stil_viata', e.target.value)} style={inputStyle}>
              {['Sedentar (birou, condus mult)','Moderat activ','Activ fizic'].map(v => <option key={v}>{v}</option>)}
            </select>
            <button onClick={() => setStep(2)} style={{
              padding: '0.75rem', borderRadius: '10px', border: 'none',
              background: '#4a4ad8', color: '#fff', fontWeight: 600, cursor: 'pointer'
            }}>Continuă →</button>
          </div>
        )}

        {step === 2 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <h3 style={{ color: '#fff' }}>Pasul 2 — Problema ta</h3>
            <select value={form.problema} onChange={e => update('problema', e.target.value)} style={inputStyle}>
              {['Sciatică','Hernie de disc lombară','Durere lombară nespecifică','Sindrom piriform','Durere cervicală','Altă problemă de spate'].map(v => <option key={v}>{v}</option>)}
            </select>
            <select value={form.durata_problema} onChange={e => update('durata_problema', e.target.value)} style={inputStyle}>
              {['Sub 2 săptămâni','2-6 săptămâni','1-6 luni','Peste 6 luni','Ani de zile'].map(v => <option key={v}>{v}</option>)}
            </select>
            <div>
              <p style={{ color: '#c0c0e0', marginBottom: '0.5rem' }}>Nivelul durerii acum: <strong style={{color:'#fff'}}>{form.nivel_durere_initial}/10</strong></p>
              <input type="range" min={1} max={10} value={form.nivel_durere_initial}
                onChange={e => update('nivel_durere_initial', parseInt(e.target.value))}
                style={{ width: '100%', accentColor: '#4a4ad8' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.25rem' }}>
                <div>
                  <span style={{ color: '#6060a0', fontSize: '0.75rem', display: 'block' }}>1</span>
                  <small style={{ color: '#6060a0', fontSize: '0.72rem' }}>Fără durere</small>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <span style={{ color: '#6060a0', fontSize: '0.75rem', display: 'block' }}>10</span>
                  <small style={{ color: '#6060a0', fontSize: '0.72rem' }}>Nu mă pot mișca/nu pot merge</small>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button onClick={() => setStep(1)} style={{
                flex: 1, padding: '0.75rem', borderRadius: '10px', border: '1px solid #2a2a4a',
                background: 'transparent', color: '#c0c0e0', cursor: 'pointer'
              }}>← Înapoi</button>
              <button onClick={() => setStep(3)} style={{
                flex: 2, padding: '0.75rem', borderRadius: '10px', border: 'none',
                background: '#4a4ad8', color: '#fff', fontWeight: 600, cursor: 'pointer'
              }}>Continuă →</button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <h3 style={{ color: '#fff' }}>Pasul 3 — Obiectivul tău</h3>
            <input placeholder="Ex: Să reduc durerea de la 7 la 3 în 30 de zile"
              value={form.obiectiv} onChange={e => update('obiectiv', e.target.value)} style={inputStyle} />
            <p style={{ color: '#6060a0', fontSize: '0.85rem' }}>
              Obiectivul te va ajuta să rămâi motivat pe parcursul recuperării.
            </p>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button onClick={() => setStep(2)} style={{
                flex: 1, padding: '0.75rem', borderRadius: '10px', border: '1px solid #2a2a4a',
                background: 'transparent', color: '#c0c0e0', cursor: 'pointer'
              }}>← Înapoi</button>
              <button onClick={handleSubmit} disabled={loading} style={{
                flex: 2, padding: '0.75rem', borderRadius: '10px', border: 'none',
                background: '#4a4ad8', color: '#fff', fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1
              }}>{loading ? 'Se salvează...' : 'Începe recuperarea'}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Onboarding;
